var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg search",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9,20.1H21.4l-.5-.5a11.65,11.65,0,0,0,2.9-7.7A11.9,11.9,0,1,0,11.9,23.8a11.65,11.65,0,0,0,7.7-2.9l.5.5v1.5L29.2,32l2.7-2.7Zm-11,0a8.2,8.2,0,1,1,8.2-8.2A8.17,8.17,0,0,1,11.9,20.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e540d238ec02afa3bc6b56ac0f83e68.svg";
export { ForwardRef as ReactComponent };